import styled, { css } from 'styled-components';

import Picture from 'components/picture';

const defaultTextAlign = css`
  text-align: center;
  ${Styles.desktop`
    text-align: left;
  `}
`;

export const BasicTileContainer = styled.div`
  border-radius: 0.75rem;
  background-color: ${Styles.color.grey.three};
  display: flex;
  padding: 0.5625rem 0 0.25rem;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  ${Styles.desktop`
    flex-direction: row;
    justify-content: flex-start;
    padding: 1.5rem;
  `};
`;

export const BasicTileTextContainer = styled.div`
  p {
    color: ${Styles.color.white};
    margin: 0;
    font-size: 0.75rem;
    ${defaultTextAlign};
    ${Styles.desktop`
      font-size: 0.9375rem;
    `}
  }
`;

export const BasicTileTitle = styled.h3`
  ${defaultTextAlign};
  color: ${Styles.color.white};
  font-family: ${Styles.fontFamily.brand};
  font-size: 0.875rem;
  line-height: 1;
  margin: 0;
  ${Styles.desktop`
    font-size: 1.25rem;
    margin: 0 0 0.43rem 0;
  `}
`;

export const BasicTileImage = styled(Picture)`
  max-height: 2.5em;
  max-width: 2.5rem;
  margin: 0 0 0.31rem 0;
  ${Styles.desktop`
    margin:0 1.5rem 0 0;
    max-height: 5em;
    max-width: 5rem;  
  `};
`;
